import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { applyTheme, getThemePreference, resolveTheme } from 'helpers/theme';

import App from './App';
import SentryService from './services/sentry.service';

applyTheme(resolveTheme(getThemePreference()));

SentryService.initSentry();

const rootEl = document.getElementById('root');

const root = createRoot(rootEl);

root.render(<App />);
